import { IComponentConfig } from "@/app/@types/base-component";
import { ReactiveComponent } from "./base-component";

export class OutOfSquare extends ReactiveComponent {
    constructor(config: IComponentConfig) {
        super({ ...config, type: "outOfSquare" });
    }
}
